import React, { useMemo } from 'react';

import { fetchEventMeetings } from '../../data/fetch';
import { useStoredDataChanged } from './useStoredDataChanged';
import Loader from './Loader';

const LoadMeetings = ({ eventId, force = false, children }) => {
    const memoizedFetchMeetings = useMemo(() => (force ? app.api.events.fetchMeetings(eventId) : fetchEventMeetings(eventId)), [force, eventId, fetchEventMeetings(eventId)]);

    useStoredDataChanged();
    return (
        <Loader skipSpinner={(state) => state.events[eventId]?.meetings.loaded} promises={[memoizedFetchMeetings]}>
            {children}
        </Loader>
    );
};

export default LoadMeetings;
